import Icon from '../components/Icon.vue'

Icon.register({
  male: {
    width: 192,
    height: 512,
    paths: [
      {
        d: 'M96 0c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM144 144c26.5 0 48 21.5 48 48v136c0 13.3-10.7 24-24 24h-16v136c0 13.3-10.7 24-24 24h-64c-13.3 0-24-10.7-24-24v-136h-16c-13.3 0-24-10.7-24-24v-136c0-26.5 21.5-48 48-48h11.4c23.7 10.9 50.6 10.4 73.3 0h11.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/male.js
// module id = 1541
// module chunks = 0